export default __webpack_public_path__ + "static/media/me.519272b7.png";